import Cookies from 'js-cookie';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import { Common } from '@src/common';
import EventBus from '@utils/bus';
import localeKo from '@locale/ko.json';
import localeJa from '@locale/ja.json';
import localeEn from '@locale/en.json';

const goPage = (path) => {
  top.location.href = path;
};

const sendEvent = (target, value) => {
  EventBus.$emit(target, value);
};

const receiveEvent = (target, callback) => {
  EventBus.$on(target, callback);
};

const compareValues = (key, order = 'asc') => {
  /*
   * How to Sort an Array of Objects
   * https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/
   */
  return function innerSort(a, b) {
    if (
      !Object.prototype.hasOwnProperty.call(a, key) ||
      !Object.prototype.hasOwnProperty.call(b, key)
    ) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];
    let comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }

    return order === 'desc' ? comparison * -1 : comparison;
  };
};

let locale = Cookies.get(Common.STORAGE_LANG);

if (locale === undefined) {
  const { language, userLanguage, systemLanguage } = navigator as any;
  const systemLocale = language || userLanguage || systemLanguage;
  locale = systemLocale.substring(0, 2);

  if (locale === Common.CONST_LANG_KO) {
    locale = Common.CONST_LANG_KO;
  } else if (locale === Common.CONST_LANG_JA) {
    locale = Common.CONST_LANG_JA;
  } else {
    locale = Common.CONST_LANG_EN;
  }

  Cookies.set(Common.STORAGE_LANG, locale);
}

Vue.use(VueRouter);
Vue.use(VueI18n);

const Lang = new VueI18n({
  locale,
  messages: {
    ko: localeKo,
    ja: localeJa,
    en: localeEn,
  },
});

export default {
  Lang,
  goPage,
  sendEvent,
  receiveEvent,
  compareValues,
};
